import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { Bau365DataAccessFairDataModule } from '@planone/bau365/data-access-fair-data';
import { SharedUiElementsModule } from '@planone/shared/ui-elements';

import { BreadcrumbComponent } from './breadcrumb/breadcrumb.component';

@NgModule({
  imports: [CommonModule, SharedUiElementsModule, Bau365DataAccessFairDataModule],
  declarations: [BreadcrumbComponent],
  exports: [BreadcrumbComponent],
})
export class Bau365FeatureBreadcrumbModule {}
